<template>
  <el-table-column
    prop="phone"
    sortable="custom"
    label="Telefon"
    show-overflow-tooltip
    fixed
    min-width="150"
  >
    <template slot-scope="scope">
      {{ scope.row.phone }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'phone',
  };
</script>
